module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat2-5e6e212f55f17c0967ae78ffe78aa3ef.jpg";